module.exports = __webpack_public_path__ + "img/jianjie.fc0a063b.png";